import { Tabs } from 'react-tabs';
import styled from 'styled-components';
import { Icon } from '../icon';

export const ZTabs = styled(Tabs)`
    .react-tabs {
        -webkit-tap-highlight-color: transparent;

        &__tab-list {
            position: relative;
            margin: 0;
            padding: 0;
            width: 100%;
            overflow: auto;
            display: flex;
            min-width: 0;
            flex-wrap: nowrap;

            &::-webkit-scrollbar {
                // small scrollbar
                height: 5px;
            }
        }

        &__tab-overflow {
            position: sticky;
            right: 0;
            top: 0;
            margin-left: auto;
            border-left: 1px solid #d2d5d8;
            padding-left: 10px !important;
            padding-right: 10px !important;
            outline-width: 8px !important;
            outline-color: rgb(246, 248, 249) !important;
            outline-style: solid !important;
        }

        &__tab {
            white-space: nowrap;
            outline: none;
            font-weight: 600;
            display: inline-block;
            list-style: none;
            padding: 8px 20px;
            cursor: pointer;
            color: ${(props) => props.theme.app.component.tabs.textColor};
            background-color: #edeeef;
            border-top: 1px solid #d2d5d8;
            border-right: 1px solid #d2d5d8;
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            &--selected {
                color: ${(props) => props.theme.app.component.tabs.active.textColor};
                background-color: #ffffff;
                border-top: 1px solid #d2d5d8;
                border-right: 1px solid #d2d5d8;
            }

            &--disabled {
                color: GrayText;
                cursor: default;
            }
            &:hover:not(.react-tabs__tab--selected) {
                background-color: ${(props) => props.theme.app.component.tabs.hover.backgroundColor};
            }
        }

        &__tab ${Icon} {
            width: 16px;
            height: 16px;
        }

        &__tab-panel {
            display: none;

            &--selected {
                display: block;
            }
        }
    }
`;
